import React,{ useEffect} from 'react'
import { connect } from 'react-redux'
import Footer from "../../components/Footer/Footer";
import NewHeader from "../../components/NewHeader/NewHeader";
import Actions from "./DoctorConfirmationActions";

const DoctorConfirmation = (props) => {

   useEffect(() => {

    props.getDoctorAssinged(props?.parsed,props.id)

   }, [])
   
    return (
      <>
        <NewHeader />
  
        <div className="container">
          <div className="subContainer">
            <div className="tkImg DocImg DocAdv">
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/b4d4a8a4-604a-49e3-976e-e9dc4e493d54.png"
                alt="Doctor Advice Image"
              />
            </div>
            <div className="tkDes">
              <div className="tkDes_msg">
                <p>
                  "Thank you for choosing Redcliffe"
                  <br /> "One of our health advisors will get in touch with you
                  shortly"
                </p>
                <div className="tkDes_msgBid">
                  <div className="msgBid_text">
                  </div>
                  {/* <div onClick={copyBookingId} className="msgBid_icons"> */}
                    {/* <MdContentCopy /> */}
                    {/* <FaShare /> */}
                  {/* </div> */}
                </div>
              </div>
              {/* <div className="tkDes_socialIcons">
                <p>Follow us on</p>
                <div className="socialIcons_box">
                  <div className="iconContainerbox">
                    <AiOutlineInstagram />
                  </div>
                  <div className="iconContainerbox">
                    <FaFacebookF />
                  </div>
                  <div className="iconContainerbox">
                    <AiOutlineTwitter />
                  </div>
                  <div className="iconContainerbox">
                    <FaLinkedinIn />
                  </div>
                  <div className="iconContainerbox">
                    <AiFillYoutube />
                  </div>
                </div>
              </div> */}
              {/* <div className="tkDes_apps">
                <p>The Redcliffe labs app is available for iOS and Android</p>
                <div className="appsContainer">
                  <img
                    src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/2d9761b1-3062-4375-8f00-da28a1e23126.png"
                    alt="playstore image"
                  />
                  <img
                    src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/0f959dad-f102-4504-ab09-5cd9b4572ba9.png"
                    alt="appstore image"
                  />
                </div>
              </div> */}
            </div>
            {/* <div className="tkOpt">
              <div className="tkOpt_box">
                <div className="tkOpt_imgBox">
                  <img
                    src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/97010cf3-e46f-4744-90cc-d26593aba1e2.svg"
                    alt="signup image"
                  />
                </div>
                <p>Exclusive sign-up offer</p>
              </div>
              <div className="tkOpt_box">
                <div className="tkOpt_imgBox">
                  <img
                    src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/e2bdad05-733b-4122-87ae-238805bff1c6.svg"
                    alt="upload image"
                  />
                </div>
                <p>Upload Prescription</p>
              </div>
              <div className="tkOpt_box">
                <div className="tkOpt_imgBox">
                  <img
                    src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/f99586ff-83c0-4889-bd77-1b4f072441ec.svg"
                    alt="getdr image"
                  />
                </div>
                <p>Get Dr Consultation</p>
              </div>
            </div> */}
            {/* <div className="tkCallback">
              <div className="tkCallback_text">
                For any queries related to your booking please{" "}
                <a href="#">Contact Us</a> or
              </div>
              <button>REQUEST A CALLBACK</button>
            </div> */}
          </div>
        </div>
  
        <Footer />
      </>
    );
  };

const mapStateToProps = (state) => ({
    
});

const mapDispatchToProps = (dispatch) => {
    return {
        getDoctorAssinged: (parsed,id) => {
            dispatch(Actions.getDoctorAssinged(parsed,id));
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(DoctorConfirmation))